import React, { FC } from 'react';
import FormBuilder from 'containers/common/sections/thank-you/FormBuilder';
import { DocumentSigned } from 'assets/images/thank-you';
import useI18n from "evcharging/hooks/useI18n";

const ThankYouPage: FC = () => {
  const { t } = useI18n();

  return (
    <FormBuilder
      image={DocumentSigned}
      title={t('thank-you.document-signed')}
      listItems={[t('thank-you.text1'), t('thank-you.text2')]}
    />
  );
};

export default ThankYouPage;
